import Chart from 'react-apexcharts'
import { ApexOptions } from 'apexcharts'
import { useTranslation } from 'react-i18next'
import { formatPercent } from '@/utils/format'

interface HorizontalBarChartProps {
  labels: string[]
  values: number[]
  total?: number
}

const HorizontalBarChart: React.FC<HorizontalBarChartProps> = ({
  labels,
  values,
  total
}) => {
  const { t, i18n } = useTranslation()
  const barHeight = labels.length * 25 + 50
  const series = [
    {
      name: t('main_chart.returned_items'),
      data: values
    }
  ]

  const chartOptions: ApexOptions = {
    chart: {
      id: `horizontal-bar-${Math.random()}`,
      type: 'bar',
      toolbar: {
        show: false
      },
      animations: {
        speed: 800,
        animateGradually: {
          enabled: true
        }
      }
    },
    colors: ['#63A2F4'],
    grid: {
      show: false,
      padding: {
        bottom: -40
      }
    },
    tooltip: {
      theme: 'dark'
    },
    plotOptions: {
      bar: {
        borderRadius: 7,
        horizontal: true,
        barHeight: 25,
        dataLabels: {
          position: 'top'
        }
      }
    },
    dataLabels: {
      offsetX: 40,
      style: {
        fontSize: '12px',
        fontFamily: 'Roobert',
        colors: ['#000']
      },
      formatter: function (val) {
        if (total && typeof val === 'number') {
          const percentage = (val / total) * 100
          return formatPercent(percentage, i18n.language, 2)
        }
        return `${val}`
      }
    },
    xaxis: {
      categories: labels,
      axisBorder: {
        show: false
      }
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          fontFamily: 'Roobert'
        }
      },
      axisBorder: {
        show: false
      },
      tooltip: {
        enabled: false
      }
    }
  }

  return (
    <Chart
      type="bar"
      options={chartOptions}
      series={series}
      height={barHeight}
    />
  )
}

export default HorizontalBarChart
